module.exports = __webpack_public_path__ + "img/zplc_pro.1005ed07.png";